import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/governance-dashboard/components/GovernanceStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/governance-dashboard/components/ParticipationChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/governance-dashboard/components/ProposalList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/governance-dashboard/components/VoteHistoryTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/AppLayout.tsx");
